var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.comList[_vm.comIndex],{ref:_vm.comList[_vm.comIndex] + '',tag:"component",attrs:{"formData":_vm.formData},on:{"tabClick":_vm.tabClick}})}
var staticRenderFns = []

export { render, staticRenderFns }